import { XIcon } from 'lucide-react';
import type { BgColor } from '~/types/pipeline';

type Props = {
  color: BgColor;
  onRemove?: () => void;
};

export function ColorSwatch({ color, onRemove }: Props) {
  const [r, g, b] = color.rgb;
  const isManual = color.weight === 0;
  return (
    <div className="flex items-center gap-2 text-xs">
      <span className="h-4 w-4 rounded border" style={{ background: `rgb(${r}, ${g}, ${b})` }} />
      <span className="font-mono text-muted-foreground">
        rgb({r},{g},{b})
      </span>
      <span className="text-muted-foreground/70">
        {isManual ? 'manual' : `${(color.weight * 100).toFixed(0)}%`}
      </span>
      {onRemove && (
        <button
          type="button"
          aria-label="Remove background color"
          onClick={onRemove}
          className="ml-auto rounded p-0.5 text-muted-foreground/70 hover:bg-muted hover:text-foreground"
        >
          <XIcon className="h-3 w-3" />
        </button>
      )}
    </div>
  );
}
